import { useContext, useState } from "react";
import Loading from "../../Loading";
import { Table } from "antd";
import { CenterContext, UserContext } from "../../../../Context";
import VND from "../../components/VND";
import Staff from "../../components/Staff";
import Location from "../../components/Location";
import MonthChoice from "../../components/MonthChoice";

import DeleteButton from "../../components/DeleteButton";

import useDB from "../../hooks/useDB";
import Error from "../../components/Error";
import removeById from "../../hooks/removeById";
import FormatDateYMD from "../../components/FormatDateYMD";
import Lang from "../../components/Lang";
import CostTypeChooser from "../../components/CostTypeChooser";
import { Button } from "@mui/material";
import SelectFromList from "../../components/SelectFromList";


export default function Costs(props) {

    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState(new Date().getMonth());
     const weekDates = getWeekDates();
  const [weekFilter, setWeekFilter] = useState("")
  const [weekly, setWeekly] = useState(false)
   const [costs, setCosts, error, loading] = useDB(weekly ? `/costs-by-week/${weekFilter ? weekFilter : weekDates[0]}`:
     `/costs?year=${year}&month=${month + 1}`
   );
    const { checkRoles } = useContext(UserContext)
    const [filter, setFilter] = useState("")
  /* 
   */
  if (loading) return <Loading />
  if(error) return <Error />

  const cols = getCols(checkRoles)



  
    


    return (
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: 24,
            marginBottom: 5,
          }}
        >
          <div>
            <Lang w="costs" />
            <Button onClick={()=>setWeekly(prev=>!prev)}>{weekly ? "Weekly" : "Monthly"}</Button>
          </div>
          <CostTypeChooser
            state={filter}
            setState={setFilter}
            style={{ width: 200 }}
            size="small"
            none
          />
          {weekly ? <SelectFromList choices={weekDates.map(w=>({_id: w, name:`${new Date(w).fDate()}`}))} value={weekFilter} setValue={setWeekFilter} size="small"/>:
          <MonthChoice
            year={year}
            month={month}
            setYear={setYear}
            setMonth={setMonth}
            style={{width:300}}
          />
          }
          <div>
            <VND
              value={costs
                .filter((c) => (filter ? c.category === filter : true))
                .reduce((a, b) => a + b.amount, 0)}
            />
            <Locations costs={costs} />
          </div>
        </div>
        <Table
          columns={cols}
          dataSource={costs
            .filter((c) => (filter ? c.category === filter : true))
            .map((c) => ({
              ...c,
              category: <Lang w={c.category} />,
              paymentMethod: c.paymentMethod === 0 ? "Cash" : "Internet",
              amount: <VND value={c.amount} />,
              date: <FormatDateYMD value={c} />,
              orderedBy: <Staff id={c.orderedBy} />,
              location: <Location id={c.location} />,
              deleteButton: checkRoles(["Accountant","Owner"])? (
                <DeleteButton
                  route={`/costs/${c._id}`}
                  success={() => removeById(setCosts, c)}
                />
              ) : null,
            }))}
        />
      </div>
    );
}

function Locations({costs}) {
  const { center} = useContext(CenterContext);
  
  return (
    <div className="text-sm">
      {center.locations
        .filter((l) => l._id !== "61f528b40cfbe8002238a964")
        .map((l) => (
          <div
            key={l._id}
            className=""
          >
            <div className="w-20">{l.name}:</div>
            <DrawFigures costs={costs} location={l._id} />
          </div>
        ))}
    </div>
  );
}

function DrawFigures({ costs, location }) {
  
  const centerCosts = costs
            .filter((c) => c.location === location)
    .reduce((a, b) => a + b.amount, 0)
  
  let allLocations = costs
            .filter((c) => c.location === "61f528b40cfbe8002238a964")
            .reduce((a, b) => a + b.amount, 0)
  if(allLocations>0) allLocations = allLocations / 2

  return (
    <div className="flex gap-3">
      <div>
        <VND value={centerCosts} />
      </div>
      <div>+</div>
      <div>
        <VND value={allLocations} />
      </div>
      <div> = </div>
      <div className="text-green-700">
        <VND value={centerCosts + allLocations} />
      </div>
    </div>
  );
}


function getCols(checkRoles) {
    const cols = [
      {
        title: "Date",
        dataIndex: "date",
        key: "date",
      },
      {
        title: "Category",
        dataIndex: "category",
        key: "category",
    
      },
      {
        title: "Description",
        dataIndex: "description",
        key: "description",
      },
      {
        title: "Person",
        dataIndex: "orderedBy",
        key: "orderedBy",
      },
      {
        title: "Location",
        dataIndex: "location",
        key: "location",
      },
      {
        title: "Method",
        dataIndex: "paymentMethod",
        key: "paymentMethod",
      },
      {
        title: "Amount",
        dataIndex: "amount",
        key: "amount",
      },
    ];
    if (checkRoles(["Accountant","Owner"])) {
        cols.push({
          title: "Delete",
          dataIndex: "deleteButton",
          key: "deleteButton",
        });
    }
    return cols
}

function getWeekDates() {
  let d = []
  let dt = new Date().startOfWeek()
  for (let i = 0; i < 8; i++){
    d.push(dt)
    dt = new Date(dt).addDays(-7).tDate()
  }
  return d
}